import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const StepsTuorqouise = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M14.826 2.714a6 6 0 0 0-5.654-.004L3 6l9 5.005 9-4.986-6.174-3.305Z"
      fill="#55CEC3"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M3.017 13.252a6 6 0 0 0 2.929 5.14L12 22V11L3 6l.017 7.252Z"
      fill="#55CEC3"
      fillRule="evenodd"
      opacity={0.8}
    />
    <path
      clipRule="evenodd"
      d="M12 11v11l6.054-3.607a6 6 0 0 0 2.93-5.141L21 6l-9 5Z"
      fill="#55CEC3"
      fillRule="evenodd"
      opacity={0.5}
    />
  </Icon>
));

export default StepsTuorqouise;
